import { render, staticRenderFns } from "./Timestamp.vue?vue&type=template&id=48c04014&scoped=true&"
import script from "./Timestamp.vue?vue&type=script&lang=js&"
export * from "./Timestamp.vue?vue&type=script&lang=js&"
import style0 from "./Timestamp.vue?vue&type=style&index=0&id=48c04014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c04014",
  null
  
)

export default component.exports